// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oXNkt{background-color:var(--anchore-background-color-paper);border-left:1px solid var(--anchore-separator-color);flex-shrink:0;overflow:hidden}.oPmkJ,.oXNkt{display:flex;flex-direction:column}.oPmkJ{height:100%}.o1JEO{flex-grow:1;overflow-y:auto}.o1JEO.pbXb5{padding:1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `oXNkt`,
	"inner": `oPmkJ`,
	"body": `o1JEO`,
	"padded": `pbXb5`
};
module.exports = ___CSS_LOADER_EXPORT___;
